import useModal from "./useModal";

export default useModal;
